import { type MatterInsurance } from "@/lib/types";
import { useCallback } from "react";
import { useNumberFormatter } from "react-aria";

const policyLimitFormatOptions = {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
} as const;

export const useFormatInsurancePolicyLimits = () => {
  const formatter = useNumberFormatter(policyLimitFormatOptions);
  const formatInsurancePolicyLimits = useCallback(
    (insurance?: MatterInsurance) => {
      if (!insurance) return;
      if (
        !insurance.policyLimitPerPerson &&
        !insurance.policyLimitPerIncident
      ) {
        return "No limits specified";
      }
      return `${formatter.format(insurance.policyLimitPerPerson ?? 0)} / ${formatter.format(insurance.policyLimitPerIncident ?? 0)}`;
    },
    [formatter],
  );
  return formatInsurancePolicyLimits;
};
